<div class="form-container">
  <div class="header-container">
    <div class="font-semibold text-xl">
      Upload Resume
    </div>
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    <button type="submit" pButton class="custom-upload-button  btn-primary mt-6">
      Upload and Next
      <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i>
    </button>
  </form>
</div>
<!-- [disabled]="form.invalid" -->
